import { useEffect, useState } from 'react';
import { Users, CreditCard, TrendingUp, Brain, Trophy, Activity } from 'lucide-react';
import api from '../../lib/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/admin/stats').then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  if (!stats) return <div className="h-64 rounded-2xl bg-slate-100 animate-pulse" />;

  const cards = [
    { icon: Users, label: 'Utenti registrati', value: stats.total_users, testId: 'stat-users' },
    { icon: CreditCard, label: 'Utenti paganti', value: stats.paying_users, testId: 'stat-paying' },
    { icon: TrendingUp, label: 'Conversion rate', value: `${stats.conversion_rate}%`, testId: 'stat-conversion' },
    { icon: Trophy, label: 'Fatturato', value: `€ ${stats.revenue.toFixed(2)}`, testId: 'stat-revenue' },
    { icon: Activity, label: 'Vendite totali', value: stats.total_sales, testId: 'stat-sales' },
    { icon: Brain, label: 'Quiz svolti', value: stats.quiz_attempts, testId: 'stat-quiz' },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {cards.map((c) => (
          <div key={c.label} className="bg-white border border-slate-200 rounded-2xl p-5" data-testid={c.testId}>
            <c.icon size={18} strokeWidth={1.5} className="text-brand mb-3" />
            <p className="font-display font-bold text-2xl text-slate-900">{c.value}</p>
            <p className="text-xs text-slate-500 mt-1">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-6">
        <h2 className="font-display font-semibold text-lg text-slate-900 mb-4">Concorsi più venduti</h2>
        {stats.top_contests.length === 0 ? (
          <p className="text-sm text-slate-500">Nessuna vendita ancora registrata.</p>
        ) : (
          <div className="divide-y divide-slate-100">
            {stats.top_contests.map((t) => (
              <div key={t.contest_id} className="flex items-center justify-between py-3" data-testid={`top-contest-${t.contest_id}`}>
                <p className="text-sm text-slate-700 font-medium truncate pr-4">{t.title}</p>
                <span className="text-sm font-bold text-brand shrink-0">{t.sales} vendite</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-6 mt-6">
        <h2 className="font-display font-semibold text-lg text-slate-900 mb-2">Engagement quiz</h2>
        <p className="text-sm text-slate-600">
          Punteggio medio complessivo: <span className="font-bold text-slate-900">{stats.quiz_avg !== null ? `${stats.quiz_avg}%` : '—'}</span>
          {' · '}Studenti attivi nel reader: <span className="font-bold text-slate-900">{stats.active_learners}</span>
        </p>
      </div>
    </div>
  );
}
